import { render } from "./XIconSolidIdCard.vue?vue&type=template&id=60f80b68"
import script from "./XIconSolidIdCard.vue?vue&type=script&lang=js"
export * from "./XIconSolidIdCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidIdCard.vue"]])

export default __exports__